import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Button from 'components/formElements/Button'
import { useState } from 'react'
import useEditor from 'hooks/useEditor'
import { useDispatch, useSelector } from 'react-redux'
import { setBillsData, setEdittedRow, setInvoiceStatues } from 'redux/features/projectDetail/projectDetailSlice'
import { useEffect } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { currencyFormatter } from 'utils/CurrencyFormatter';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { userInfo } from 'utils/Auth'
import Icons from 'assets/icons'
import { Calendar } from 'primereact/calendar';
import moment from 'moment'
import { Tooltip } from 'primereact/tooltip'

const PaymentReport = () => {

    const [getBillsData] = useRequest()
    const [getInvoicesStatus] = useRequest()
    const [request] = useRequest()
    const [selectedRow, setSelectedRow] = useState(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [customerName, setCustomerName] = useState('');
    const { projectDetail } = useSelector((state) => state)
    const { billsData } = projectDetail
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [note, setNote] = useState();
    const [key, setKey] = useState(false);
    const [visibleDateDialog, setVisibleDateDialog] = useState(false);
    const [addForm, setAddForm] = useState({
        endDate: null,
    })
    const [dateKey, setDateKey] = useState(false);

    const { showToast } = useToast()
    const dispatch = useDispatch()
    const { textEditor, currencyEditor } = useEditor()

    useEffect(() => {

        getBillsData('/Invoices/GetAllInvoices', {
            method: 'GET', params: { invoiceStatus: "kesildi" }
        }).then((res) => {
            if (res?.data?.ok) {
                setLoading(false);
                const data = res.data.result
                dispatch(setBillsData(data))
                setCustomerName(data.filter((a, i) => data.findIndex((s) => (a.projectCustomerDisplayName ?? a.project?.customerName) === (s.projectCustomerDisplayName ?? s.project?.customerName)) === i))
            }
        })
        getInvoicesStatus('/InvoiceStatus/GetAllInvoiceStatuses', { method: 'GET' }).then(res => {
            if (res?.data?.ok) {
                dispatch(setInvoiceStatues(res.data.result.map(d => {
                    return { value: d.id, label: d.name }
                })))
            }
        })
    }, [])

    const handleChange = (e) => {
        setAddForm(prev => ({ ...prev, [e.name]: e.value }))
    }

    const footerContent = () => (
        <div style={{ display: "flex", justifyContent: "end" }}>
            <Button title="Not Ekle" handleClick={() => onRowEditComplete1(key)} className="btn-success" ></Button>
            <Button title="Vazgeç" handleClick={() => setVisible(false)} className="btn-danger" > </Button>
        </div>
    );
    const footerContent2 = () => (
        <div style={{ display: "flex", justifyContent: "end" }}>
            <Button title="Onayla" handleClick={() => onRowEditComplete2(dateKey)} className="btn-success" />
            <Button title="Vazgeç" handleClick={() => setVisibleDateDialog(false)} className="btn-danger" />
        </div>
    );
    const renderHeader2 = () => {
        return (
            <div className="flex justify-content-between ">
                <div>
                    <span className="p-input-icon-left ">
                        <i className="pi pi-search" />
                        <InputText
                            style={{ maxWidth: "20rem" }}
                            inputId="dropdown" placeholder="Müşteri / Şirket Adı" value={globalFilterValue} options={customerName} onChange={onGlobalFilterChange} optionLabel="project.customerName" />
                    </span>
                </div>
            </div>
        )
    }

    const onRowEditComplete1 = () => {

        if (!note) {
            showToast('Not Ekleyiniz.', 'error')
        } else {
            request('/Invoices/UpdateInvoicesNote', {
                method: 'PUT',
                params: { invoceId: selectedRow?.id, note: note }
            }).then((res) => {
                if (res?.data) {
                    getBillsData('/Invoices/GetAllInvoices', {
                        method: 'GET',
                    }).then((res) => {
                        if (res.data.ok) {
                            const data = res.data.result
                            setCustomerName(data)
                            getBillsData('/Invoices/GetAllInvoices', {
                                method: 'GET', params: { invoiceStatus: "kesildi" }
                            }).then((res) => {
                                if (res?.data?.ok) {
                                    setLoading(false);
                                    const data = res.data.result
                                    dispatch(setBillsData(data))
                                    setVisible(false)
                                    setCustomerName(data.filter((a, i) => data.findIndex((s) => (a.projectCustomerDisplayName ?? a.project?.customerName) === (s.projectCustomerDisplayName ?? s.project?.customerName)) === i))
                                }
                            })
                            showToast('Faturaya Not Eklendi.', 'success')
                            dispatch(setEdittedRow({}))
                        }
                    })
                }
            })
        }
    }

    const onRowEditComplete2 = () => {
        let _products2 = [...billsData];
        if (!addForm.endDate) {
            showToast('Ödeme Tarihini Giriniz.', 'error')
        } else {
            request('/Invoices/UpdateInvoicesPaid', {
                method: 'PUT',
                params: { invoceId: selectedRow?.id, paidTime: addForm.endDate }
            }).then((res) => {
                if (res?.data.ok) {
                    dispatch(setBillsData(_products2.filter(p => p.id != selectedRow?.id)))
                    setSelectedRow(null)
                    setVisibleDateDialog(false)
                    showToast('Fatura Bilgisi Güncellendi.', 'success')
                }
                dispatch(setEdittedRow({}))
            })
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    }

    const header2 = renderHeader2();

    const openDialog = (rowData, key) => {
        setSelectedRow(rowData)
        setVisible(true)
        setKey(key)
    }

    const openDateDialog = (rowData, key) => {
        setVisibleDateDialog(true)
        setSelectedRow(rowData)
        setDateKey(key)
    }
    const getProjectCustomerDisplay = (row) => row?.projectCustomerDisplayName ?? row?.project?.customerName
    const filteredData = globalFilterValue ? billsData?.filter(f => getProjectCustomerDisplay(f)?.toLocaleLowerCase('tr')?.includes(globalFilterValue?.toLocaleLowerCase('tr')) || f?.project?.name?.toLocaleLowerCase('tr')?.includes(globalFilterValue?.toLocaleLowerCase('tr'))) : billsData

    return userInfo['Invoice.read']?.includes('True') &&
        <AnimatedSpan className='page-container d-flex flex-column'>
            <Dialog header="Not Ekle" visible={visible} style={{
                width: '30rem'

            }} onHide={() => setVisible(false)} footer={footerContent()}>
                <div className='form-control'>
                    <textarea
                        placeholder='Not Giriniz' value={note} onChange={(e) => setNote(e.target.value)} rows={5} cols={30} />

                </div>

            </Dialog>

            <Dialog header="Ödeme Tarihi Giriniz" visible={visibleDateDialog} style={{
                width: '30rem'

            }} onHide={() => setVisibleDateDialog(false)} footer={footerContent2()}>

                <div className='col-md-12'>
                    <div className='form-control'>
                        <Calendar
                            dateFormat='dd/mm/yy'
                            placeholder='Ödeme Tarihi Giriniz'
                            name='endDate'
                            onChange={(e) => {
                                handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
                            }}
                        />
                    </div>
                </div>

                <Tooltip target=".custom-target-icon" />

            </Dialog>
            <div className='row-margin-x'>
                <div className='col-md-12'>
                    <DataTable
                        responsiveLayout="scroll"
                        loading={loading}
                        header={header2}
                        editMode='row'
                        dataKey='id'
                        className='p-1'
                        onRowEditComplete={onRowEditComplete1}
                        value={filteredData}
                        onRowEditInit={e => dispatch(setEdittedRow(e.data))}
                    >
                        <Column
                            className='text-semi-bold text-sm'
                            field='project.customerName'
                            style={{ width: "auto" }}
                            header='Müşteri / Şirket Adı '
                            sortable='true'
                            body={(rowData) => {
                                const displayName = rowData?.projectCustomerDisplayName ?? rowData?.project?.customerName
                                return <div>{displayName && `${displayName}`}</div>
                            }}
                            />

                        <Column
                            className='text-semi-bold text-sm'
                            field='project.name'
                            style={{ width: "auto" }}
                            header='Proje Adı'
                            editor={(options) =>
                                textEditor(options)
                            } />
                        <Column
                            className='text-semi-bold text-sm'
                            field='name'
                            style={{ width: "auto" }}
                            header='Fatura Adımı'
                            editor={(options) =>
                                textEditor(options)
                            } />
                        <Column
                            className='text-semi-bold text-sm'
                            style={{ width: "auto" }}
                            headerClassName='text-bold bg-primary text-default'
                            field='amount'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {currencyFormatter(rowData.amount)} {rowData.currency}
                                    </span>
                                )
                            }}
                            header='Tutar'

                            editor={(options) => currencyEditor(options)} />
                            <Column
                                className='text-semi-bold text-sm'
                                headerClassName='text-bold bg-primary text-default'
                                field='invoiceNo'
                                header='Fatura No'
                                sortable='true'
                                style={{ width: '8rem' }}
                                body={(rowData) => {
                                    return (
                                        <span>
                                            {rowData.invoiceNo ? rowData.invoiceNo : "-"}
                                        </span>
                                    )
                                }}
                            />
                        <Column
                            className='text-semi-bold text-sm'
                            style={{ width: "auto" }}
                            headerClassName='text-bold bg-primary text-default'
                            field='description'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {rowData.description ? rowData.description : "-"}
                                    </span>
                                )
                            }}
                            header='Açıklama'
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            style={{ width: "auto" }}
                            headerClassName='text-bold bg-primary text-default'
                            field='note'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {rowData.note ? rowData.note : "-"}
                                    </span>
                                )
                            }}
                            header='Not'

                            editor={(options) => currencyEditor(options)} />
                        <Column
                            rowEditor
                            style={{ width: '1rem' }}
                            headerClassName='text-bold bg-primary text-default '
                            body={(rowData, key) =>
                                <div style={{
                                    display: "flex", justifyContent: "space-between",
                                    width: "13rem"
                                }}>
                                    <Button handleClick={() => openDateDialog(rowData, key)} style={{ borderRadius: "10rem", fontSize: "0.8rem", width: "6rem" }} title='Ödendi' icon={<Icons.money />} className='btn-bill' />
                                    <Button handleClick={() => openDialog(rowData, key)} style={{ borderRadius: "10rem", fontSize: "0.8rem", width: "6rem" }} icon={<Icons.note />} title='Not Ekle' className='btn-bill' />
                                </div>}
                        />

                    </DataTable>
                </div>
            </div>

        </AnimatedSpan>
}

export default PaymentReport
